import React from 'react';
import Button from '@mui/material/Button';

const CancelButton = () => {
  const handleCancelClick = () => {
    window.closeKeepeekWindow?.();
  };
  return (
    <Button variant="contained" color="secondary" onClick={handleCancelClick}>
      Cancel
    </Button>
  );
};

export default CancelButton;
